define([
	"dojo/_base/declare",
	"csi/heading/Expression"
], function(declare,Expression) {

	return declare(Expression, {
		_getValue: function(/*Context*/ctx, /*Heading*/h) {
			// summary: count number of unique paths - show empty cell if view not resolved
			var	paths = ctx.view._getViewPaths(ctx);
			return paths ? paths.length : "";
		}
	});
});